import { useAppSelector } from 'shared/hooks'

import type { RootState } from '../../../redux/store'

import { appSelectors } from '../../../redux/reducers/app'

function selectHasTeam(state: RootState) {
	const { isTeamPlanAccessible, teamId } = appSelectors.persona(state) ?? {}
	return Boolean(isTeamPlanAccessible && teamId)
}

export const useIsEnable = () => useAppSelector(selectHasTeam)
